"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var enums_1 = require("../../../../common/enums");
var __1 = require("../");
var utils_1 = require("../../../../utils");
var ReportDateSelector_1 = require("./ReportDateSelector");
var utils_2 = require("@vidazoo/ui/lib/components/utils");
var lib_1 = require("../../../../lib");
var MetricsTip = function (_a) {
    var onSupportClick = _a.onSupportClick;
    return (React.createElement("div", { className: theme.linkedTip },
        React.createElement("div", null,
            "Metrics are measures of quantitative",
            React.createElement("br", null),
            "assessment used for measurement",
            React.createElement("br", null),
            "or tracking performance."),
        onSupportClick ? React.createElement(ui_1.LinkButton, { onClick: onSupportClick, className: theme.link, iconSize: 1.6, type: "button", iconName: "icon-help-support", blue: true, small: true }, "Help & Support") : null));
};
var ReportingHeader = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingHeader, _super);
    function ReportingHeader(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onPresetChange = function (preset) {
            var onPresetChange = _this.props.onPresetChange;
            onPresetChange(preset);
        };
        _this.onTimezoneChange = function (e) {
            var onTimezoneChange = _this.props.onTimezoneChange;
            onTimezoneChange(e.target.value);
        };
        _this.onPeriodChange = function (e) {
            var onPeriodChange = _this.props.onPeriodChange;
            onPeriodChange(e.target.value);
        };
        _this.onIsCompareChange = function (e) {
            var onIsCompareChange = _this.props.onIsCompareChange;
            onIsCompareChange(utils_1.normalizeEventValue(e));
        };
        _this.onDocumentKeyDown = function (e) {
            var eventObj = window.event ? event : e;
            if (eventObj.keyCode === 90 && (eventObj.ctrlKey || eventObj.metaKey)) {
                _this.props.rollBackParams();
            }
        };
        _this.copyMetrics = function () {
            lib_1.MemoryClipboard.copy(window.getSelection().toString() || _this.props.selectedMetrics.map(function (m) { return m.label; }).join(", "));
        };
        _this.copyDimensions = function () {
            lib_1.MemoryClipboard.copy(window.getSelection().toString() || _this.props.selectedDimensions.map(function (d) { return d.label; }).join(", "));
        };
        _this.copyFilters = function (filter) {
            lib_1.MemoryClipboard.copy(filter.values.map(function (item) {
                if (typeof item === "string") {
                    return item;
                }
                else if (typeof item === "object") {
                    return item[filter.filterLabelKey];
                }
            }).join(", "));
        };
        return _this;
    }
    ReportingHeader.prototype.componentDidMount = function () {
        if (this.props.rollBackParams) {
            utils_2.addEventsToDocument(this.getMouseEventMap());
        }
    };
    ReportingHeader.prototype.componentWillUnmount = function () {
        if (this.props.rollBackParams) {
            utils_2.removeEventsFromDocument(this.getMouseEventMap());
        }
    };
    ReportingHeader.prototype.getMouseEventMap = function () {
        return {
            keydown: this.onDocumentKeyDown,
        };
    };
    ReportingHeader.prototype.getContextMenuItems = function (type, pasteMultiple, customCopy) {
        var onClearAllParams = this.props.onClearAllParams;
        var clearAllLabel = "";
        var onCopy;
        switch (type) {
            case enums_1.ContextMenuItemsType.fields:
                clearAllLabel = "Clear All Metrics";
                onCopy = this.copyMetrics;
                break;
            case enums_1.ContextMenuItemsType.groups:
                clearAllLabel = "Clear All Dimensions";
                onCopy = this.copyDimensions;
                break;
            case enums_1.ContextMenuItemsType.filters:
                clearAllLabel = "Clear All Filters";
                break;
            case enums_1.ContextMenuItemsType.constraints:
                clearAllLabel = "Clear All Constraints";
                break;
            case enums_1.ContextMenuItemsType.subGroups:
                clearAllLabel = "Clear All Sub Dimensions";
                break;
        }
        var contextMenuItems = [
            { label: clearAllLabel, onClick: function () { return onClearAllParams(type); } },
        ];
        var copyFn = customCopy || onCopy;
        if (copyFn) {
            contextMenuItems.push({ label: "Copy", onClick: copyFn });
        }
        if (pasteMultiple) {
            contextMenuItems.push({ label: "Paste Multiple", onClick: pasteMultiple });
        }
        return contextMenuItems;
    };
    ReportingHeader.prototype.render = function () {
        var _this = this;
        var _a = this.props, timezone = _a.timezone, activePreset = _a.preset, activePeriod = _a.period, title = _a.title, titleIconName = _a.titleIconName, isLoading = _a.isLoading, allowCompare = _a.allowCompare, fromDate = _a.fromDate, toDate = _a.toDate, isCompare = _a.isCompare, compareFromDate = _a.compareFromDate, compareToDate = _a.compareToDate, dimensions = _a.dimensions, filterDimensions = _a.filterDimensions, selectedDimensions = _a.selectedDimensions, metrics = _a.metrics, selectedMetrics = _a.selectedMetrics, onGenerateReport = _a.onGenerateReport, onReset = _a.onReset, onAddConstraint = _a.onAddConstraint, onAddFilter = _a.onAddFilter, onFromChange = _a.onFromChange, onToChange = _a.onToChange, onCompareFromChange = _a.onCompareFromChange, onCompareToChange = _a.onCompareToChange, onOrderDimensions = _a.onOrderDimensions, onOrderMetrics = _a.onOrderMetrics, onDeleteDimension = _a.onDeleteDimension, onDeleteMetric = _a.onDeleteMetric, onAddDimension = _a.onAddDimension, onAddMetric = _a.onAddMetric, constraints = _a.constraints, onChangeConstraint = _a.onChangeConstraint, onDeleteConstraint = _a.onDeleteConstraint, filters = _a.filters, onChangeFilter = _a.onChangeFilter, onDeleteFilter = _a.onDeleteFilter, onAddFilterValue = _a.onAddFilterValue, onRemoveFilterValue = _a.onRemoveFilterValue, disabled = _a.disabled, onCopyLink = _a.onCopyLink, onDownloadCSV = _a.onDownloadCSV, onSaveScheduledReport = _a.onSaveScheduledReport, onPresetReport = _a.onPresetReport, onOfflineReport = _a.onOfflineReport, onSupportClick = _a.onSupportClick, minWindowWidthToGroupActions = _a.minWindowWidthToGroupActions, useExtendedTimezonePicker = _a.useExtendedTimezonePicker, isGenerateReportDisabled = _a.isGenerateReportDisabled, customAction = _a.customAction, onMultiplePaste = _a.onMultiplePaste, useReportHistory = _a.useReportHistory, selectedHistoryReport = _a.selectedHistoryReport, onBackToHistoryReports = _a.onBackToHistoryReports;
        return (React.createElement(ui_1.Form, { onSubmit: onGenerateReport },
            React.createElement(ui_1.Surface, { className: theme.surface, level: 1 },
                React.createElement("div", { className: theme.top },
                    title ? React.createElement(ui_1.PageTitle, { className: theme.title, iconName: titleIconName, label: title }) : null,
                    React.createElement(ui_1.ButtonsGroup, { onChange: this.onPresetChange, active: activePreset, disabled: isLoading, className: theme.preset }, enums_1.ReportingTimePreset.map(function (preset) { return React.createElement(ui_1.GroupButton, { key: preset.value, name: preset.value }, preset.label); }))),
                React.createElement("div", null,
                    React.createElement("div", { className: theme.timeSelectors },
                        React.createElement("div", { className: theme.selectors },
                            React.createElement(ReportDateSelector_1.default, tslib_1.__assign({}, {
                                fromDate: fromDate,
                                toDate: toDate,
                                onFromChange: onFromChange,
                                onToChange: onToChange,
                                onTimezoneChange: this.onTimezoneChange,
                                timezone: timezone,
                                useExtendedTimezonePicker: useExtendedTimezonePicker,
                                isLoading: isLoading,
                                withTimezone: true,
                                withPeriod: false
                            })),
                            allowCompare ?
                                React.createElement(ui_1.Collapsable, { collapsed: !isCompare },
                                    React.createElement(ui_1.Label, { className: theme.compareTitle, size: 13, weight: 700, spacing: 1.25 }, "Compare to"),
                                    React.createElement(ReportDateSelector_1.default, tslib_1.__assign({}, {
                                        fromDate: compareFromDate,
                                        toDate: compareToDate,
                                        onFromChange: onCompareFromChange,
                                        onToChange: onCompareToChange,
                                        useExtendedTimezonePicker: useExtendedTimezonePicker,
                                        isLoading: isLoading,
                                        period: activePeriod,
                                        onPeriodChange: this.onPeriodChange,
                                        withTimezone: false,
                                        withPeriod: true
                                    })))
                                : null),
                        allowCompare ?
                            React.createElement(ui_1.Switch, { className: theme.compareSwitch, small: true, label: "Compare Dates", checked: isCompare, onChange: this.onIsCompareChange }) : null)),
                React.createElement("div", { className: theme.bottom },
                    React.createElement("div", { className: theme.left },
                        React.createElement(ui_1.ContextMenu, { items: this.getContextMenuItems(enums_1.ContextMenuItemsType.groups, function () { return onMultiplePaste("groups"); }) },
                            React.createElement("div", { className: theme.dimentions },
                                React.createElement("div", { className: theme.chipsHeader },
                                    React.createElement("div", { className: theme.description },
                                        React.createElement("div", { className: theme.label }, "Dimensions"),
                                        React.createElement(ui_1.Infocon, { className: theme.infocon, leaveOpenOnMouseOver: true, title: React.createElement("div", null,
                                                "Dimensions are attributes of your data.",
                                                React.createElement("br", null),
                                                "The values of dimensions are groups of",
                                                React.createElement("br", null),
                                                "Strings and Booleans."), position: "bottom" })),
                                    React.createElement(ui_1.LinkButton, { type: "button", className: theme.link, iconName: "icon-plus-small", deepPurple: true, small: true, uppercase: true, spaced: true, bold: true, onClick: onAddFilter }, "Add Filter")),
                                React.createElement(ui_1.Chips, { fill: true, deepPurple: true, allowOrder: true, chips: selectedDimensions, maxItems: 5, leaveOpenAfterSelect: true, onDelete: onDeleteDimension, onOrder: onOrderDimensions, onSelect: onAddDimension, dataSource: dimensions, searchPlaceholder: "Add Dimension", emptyPlaceholder: "Add Dimension", autoCompleteListWidth: 300 }))),
                        React.createElement("div", { className: theme.filters }, filters.map(function (filter, idx) {
                            var pasteFn = filter.key ? function () { return onMultiplePaste("filters", filter); } : null;
                            var copyFn = function () { return _this.copyFilters(filter); };
                            return (React.createElement(ui_1.ContextMenu, { items: _this.getContextMenuItems(enums_1.ContextMenuItemsType.filters, pasteFn, copyFn), key: filter.id },
                                React.createElement("div", null,
                                    React.createElement(__1.ReportingFilter, { key: filter.id, index: idx, groups: filterDimensions, filter: filter, onChange: onChangeFilter, onDelete: onDeleteFilter, onAddValue: onAddFilterValue, onDeleteValue: onRemoveFilterValue }))));
                        }))),
                    React.createElement("div", { className: theme.right },
                        React.createElement(ui_1.ContextMenu, { items: this.getContextMenuItems(enums_1.ContextMenuItemsType.fields, function () { return onMultiplePaste("fields"); }) },
                            React.createElement("div", { className: theme.metrics },
                                React.createElement("div", { className: theme.chipsHeader },
                                    React.createElement("div", { className: theme.description },
                                        React.createElement("div", { className: theme.label }, "Metrics"),
                                        React.createElement(ui_1.Infocon, { className: theme.infocon, leaveOpenOnMouseOver: true, title: React.createElement(MetricsTip, { onSupportClick: onSupportClick }), position: "bottom" })),
                                    React.createElement(ui_1.LinkButton, { type: "button", className: theme.link, iconName: "icon-plus-small", deepPurple: true, small: true, uppercase: true, spaced: true, bold: true, onClick: onAddConstraint }, "Add Constraint")),
                                React.createElement(ui_1.Chips, { fill: true, deepPurple: true, allowOrder: true, chips: selectedMetrics, maxItems: 5, leaveOpenAfterSelect: true, onDelete: onDeleteMetric, onOrder: onOrderMetrics, onSelect: onAddMetric, dataSource: metrics, searchPlaceholder: "Add Metric", emptyPlaceholder: "Add Metric", autoCompleteListWidth: 300 }))),
                        React.createElement(ui_1.ContextMenu, { items: this.getContextMenuItems(enums_1.ContextMenuItemsType.constraints) },
                            React.createElement("div", { className: theme.constraints }, constraints.map(function (constraint, idx) { return React.createElement(__1.ReportingConstraint, { key: constraint.id, index: idx, fields: metrics, constraint: constraint, onChange: onChangeConstraint, onDelete: onDeleteConstraint }); }))))),
                React.createElement("div", { className: theme.actions },
                    React.createElement("div", null,
                        React.createElement(__1.ReportingActions, { disabled: isLoading || disabled, onCopyLink: onCopyLink, onDownloadCSV: onDownloadCSV, onSaveScheduledReport: onSaveScheduledReport, onPresetReport: onPresetReport, onOfflineReport: onOfflineReport, minWindowWidthToGroupActions: minWindowWidthToGroupActions, customAction: customAction })),
                    React.createElement("div", { className: "flex flex-align-center" },
                        React.createElement(ui_1.Button, { type: "button", uppercase: true, gray: true, medium: true, onClick: onReset }, "Clear All"),
                        (selectedHistoryReport && useReportHistory && onBackToHistoryReports) ? (React.createElement(ui_1.Button, { type: "button", iconName: "icon-history", uppercase: true, green: true, medium: true, onClick: onBackToHistoryReports }, "History Reports")) : null,
                        React.createElement(ui_1.Button, { type: "submit", uppercase: true, blue: true, medium: true, disabled: isGenerateReportDisabled }, "Generate Report"))))));
    };
    ReportingHeader.defaultProps = {
        dimensions: [],
        selectedDimensions: [],
        metrics: [],
        selectedMetrics: [],
        titleIconName: "icon-reporting",
        useExtendedTimezonePicker: true
    };
    return ReportingHeader;
}(React.Component));
exports.default = ReportingHeader;
